<template>
<v-container>
    <v-row :justify="`center`">
        <v-col md="8"> <!-- the center column -->
            <v-container fluid>
                <v-row>
                    <v-col cols=12 sm="4" class="center">
                        <v-avatar size="136" :style="{backgroundColor: htmlColor}">
                            <span class="text-6xl">{{initials}}</span>
                        </v-avatar>
                    </v-col>
                    <v-col sm="8">
                        <div class="text-4xl">
                            {{formattedFirstName}} {{formattedLastName}}
                        </div>
                        <div class="text py-2">
                            {{ user.title ? user.title : "No Title" }}
                        </div>
                        <ContactRow type="Work Phone" :contactInfo="user.work_phone" />
                        <ContactRow type="Personal Phone" :contactInfo="user.personal_phone ? user.personal_phone : '+18001231234'" />
                        <ContactRow type="Work Email" :contactInfo="user.work_email" />

                        <div class="pt-8 right-align">
                            <v-btn v-if="profileIsCurrentUsers" class="rounded-3xl" style="display:none;">EDIT PROFILE</v-btn>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="12" xl="12">
                        <div class="text-2xl bottom-divider uppercase">
                            EMPLOYER
                        </div>

                    </v-col>
                    <v-col xs="12">
                        <EmployerCard :employerId="user.employer_company_id" :companyDataURL="user.employer_company_data" />
                    </v-col>
                </v-row>
            </v-container>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
/* Example response:
{
    "data": {
        "first_name": "James",
        "last_name": "Kelsey",
        "work_email": null,
        "work_phone": "+13607204094",
        "employer_name": "Axon Collective",
        "employer_company_id": 1,
        "employer_company_data": "/api/company/1",
        "co_sellers_data": "/api/user/2/co_sellers/",
        "client_data": "/api/user/2/clients/"
    }
}
*/
import axios from 'axios';
import EmployerCard from '../components/content/profile/EmployerCard.vue';
import ContactRow from '../components/content/profile/ContactRow.vue';

export default {
    name: "Profile",
    components: { EmployerCard, ContactRow },
    mounted() {
        this.getUserData();
    },
    data() {
        return {
            user: {
                "first_name": "",
                "last_name": "",
                "work_email": null,
                "work_phone": "+1112223333",
                "employer_name": "",
                "employer_company_id": null,
                "employer_company_data": "",
                "co_sellers_data": "",
                "client_data": ""
            }
        };
    },
    methods: {
        getUserData () {
            const userId = this.$route.params.userId ? this.$route.params.userId : this.$store.state.id
            axios({
                method: "get",
                url: `${this.$store.getters.baseURL}/api/user/${userId}`,
                headers: {
                    "Authorization": `Token ${this.$store.state.userToken}`
                }
            })
                .then(res => {
                this.user = res.data
            })
                .catch(err => {
                console.error(err)
            });
        },
        capitalFirst (name) {
            return `${name.toUpperCase().slice(0,1)}${name.toLowerCase().slice(1,)}`
        },
    },
    computed: {
        formattedFirstName () {
            return this.capitalFirst(this.user.first_name)

        },
        formattedLastName () {
            return this.capitalFirst(this.user.last_name)
        },
        initials () {
            const fi = this.user.first_name.length > 0 ? this.user.first_name[0] : ''
            const li = this.user.last_name.length > 0 ? this.user.last_name[0] : ''
            return `${fi}${li}`.toUpperCase()
        },
        htmlColor () {
            const colors = [
                'aliceblue',
                'lightsalmon',
                'lightcoral',
                'lightpink',
                'lemonchiffon',
                'thistle',
                'mediumseagreen',
                'cadetblue',
                'powderblue',
                'slategray',
            ]
            return colors[Math.floor(Math.random() * colors.length)]
        },
        profileIsCurrentUsers () {
            return this.$route.params.userId === this.$store.id;
        }
    },
    watch: {
        '$route' () {
            this.getUserData()
        }
    }

}
</script>

<style scoped>
.bottom-divider {
    border-bottom: 1px solid #D9D9D9
}

.center {
    display: flex;
    justify-content: center;
}

.flex-column {
    flex-direction: column;
}

.right-align {
    display: flex;
    justify-content: flex-end;
}

@media screen and (max-width: 600px) {
    .v-avatar {
        display: none;
    }
}
</style>
